import { BaseLayoutFactory } from '../../../components/base-layout-factory';
import { AuditSearchProvider } from './context/audit-search-context';
import { AuditSearchComponent } from './audit-search-component';

export function AuditSearchFactory() {
    return (
        <BaseLayoutFactory>
            <AuditSearchProvider>
                <AuditSearchComponent />
            </AuditSearchProvider>
        </BaseLayoutFactory>
    );
}
